import Base64Encoder from './base_64_encoder';
const base64Encoder = new Base64Encoder();

var settings = {
  username: process.env.API_BASICAUTH_ID || 'hoegekis_staging',
  password: process.env.API_BASICAUTH_SECRET || 'super_secret_var'
};

function BasicAuthSettings() { }

BasicAuthSettings.prototype.getUsername = function () {
  return settings.username;
};

BasicAuthSettings.prototype.getPassword = function () {
  return settings.password;
};

BasicAuthSettings.prototype.getBaseUrl = function () {
  return settings.apiHost;
};

BasicAuthSettings.prototype.authenticateHeader = function (headers = undefined) {
  if (headers === undefined) {
    headers = new Headers();
  }
  let key = this.getUsername() + ':' + this.getPassword();

  key = base64Encoder.encode(key);
  headers.Authorization = 'Basic ' + key;
  return headers;
};

export default BasicAuthSettings;
